import React, { useEffect, useRef, useState } from 'react';
import { useParams, Route, Routes } from 'react-router-dom';
import StormwaterProject from './StormwaterProject';
import SiteDocsContainer from './siteDocs/SiteDocsContainer';
import MapsContainer from './siteMaps/MapsContainer';
import StormwaterLayout from './StormwaterLayout';
import SWHome from './SWHome';
import SiteContactsContainer from './siteContacts/SiteContactsContainer';
import SiteLogsContainer from './siteLogs/SiteLogsContainer';
import SiteRainLogsContainer from './siteLogs/SiteRainLogsContainer';
import PermitContainer from './sitePermits/PermitContainer';
import InspectionContainer from './Inspections/InspectionContainer';
import { downloadBlob, downloadBlobFromResponse } from "../../Scripts/FileUtilities";
import { createZipBlob } from '../../Scripts/ZipUtilities';
import { createMapPdfFromRevisionResponse, handleMapDocumentResponse, handleStandardDocumentResponse, } from './stormwaterDocumentActions';
import { getSelectedMapLatestRevisions } from './siteMaps/MapPdfService';
import ModalComponent from '../Common/ModalComponent';

export default function StormwaterProjectContainer() {
    const params = useParams();
    const siteId = params.siteId;
    const [selectedMenuData, setSelectedMenuData] = useState({ selectedMenu: '', selectedOn: new Date() });
    const [viewerDocumentData, setViewDocumentData] = useState();
    const [siteData, setSiteData] = useState({ loading: false });
    const [siteDocsData, setSiteDocsData] = useState({ loading: false });
    const [siteInspectionsData, setSiteInspectionsData] = useState({ loading: false });
    const [siteAmendmentsData, setSiteAmendmentsData] = useState({ loading: false });
    const [sitePermitsData, setSitePermitsData] = useState({ loading: false });
    const [siteSwpppsData, setSiteSwpppData] = useState({ loading: false });
    const [siteContactsData, setSiteContactsData] = useState({ loading: false });
    const [siteGradingLogsData, setSiteGradingLogsData] = useState({ loading: false });
    const [siteGradingLogEntriesData, setSiteGradingLogEntriesData] = useState();
    const [siteLotStabilizationLogsData, setSiteLotStabilizationLogsData] = useState({ loading: false });
    const [siteLotStabilizationLogEntriesData, setSiteLotStabilizationLogEntriesData] = useState();
    const [siteQualifyingEventLogsData, setSiteQualifyingEventLogsData] = useState({ loading: false });
    const [siteStormLogsData, setSiteStormLogsData] = useState({ loading: false });
    const [siteRainLogsData, setSiteRainLogsData] = useState({ loading: false });
    const [siteMapsData, setSiteMapsData] = useState({ loading: false, selected: false });
    const [permitSummariesData, setPermitSummariesData] = useState({ loading: false });
    const [downloadDocsProgress, setDownloadDocsProgress] = useState({ totalBatches: 1, completedBatches: 1, isDownloadCompleted: true, isSingleDocument: false, documentCont: 0 });

    const abortDownloadRef = useRef(undefined);
    const downloadTimeoutRef = useRef(undefined);
    

    useEffect(() => handleGetSite(siteId), [siteId]);
    useEffect(() => handleGetSiteDocuments(siteId), [siteId]);
    useEffect(() => handleGetSiteInspections(siteId), [siteId]);
    useEffect(() => handleGetSiteAmendments(siteId), [siteId]);
    useEffect(() => handleGetSitePermits(siteId), [siteId]);
    useEffect(() => handleGetSiteSwppps(siteId), [siteId]);
    useEffect(() => handleGetSiteContacts(siteId), [siteId]);
    useEffect(() => handleGetSiteGradingLogs(siteId, selectedMenuData), [siteId, selectedMenuData]);
    useEffect(() => handleGetSiteLotStabilizationLogs(siteId, selectedMenuData), [siteId, selectedMenuData]);
    useEffect(() => clearGradingAndStabilizationLogEntries(selectedMenuData, siteGradingLogEntriesData), [selectedMenuData, siteGradingLogEntriesData]);
    useEffect(() => clearGradingAndStabilizationLogEntries(selectedMenuData, siteLotStabilizationLogEntriesData), [selectedMenuData, siteLotStabilizationLogEntriesData]);
    useEffect(() => handleGetQualifyingEventLogs(siteId), [siteId, selectedMenuData]);
    useEffect(() => handleGetStormLogs(siteId), [siteId, selectedMenuData]);
    useEffect(() => handleGetRainLogs(siteId), [siteId, selectedMenuData]);
    useEffect(() => handleGetMaps(siteId), [siteId, selectedMenuData]);
    useEffect(() => handleGetPermitSummaries(siteId, selectedMenuData), [siteId, selectedMenuData]);

    function clearGradingAndStabilizationLogEntries(selectedMenuData, LogEntriesData) {
        if (selectedMenuData.selectedMenu !== "siteGradingLogs" && LogEntriesData !== undefined) {
            setSiteGradingLogEntriesData();
        }

        if (selectedMenuData.selectedMenu !== "siteLotStabilizationLogs" && LogEntriesData !== undefined) {
            setSiteLotStabilizationLogEntriesData();
        }
    }

    function handleGetSite(siteId) {
        var url = `Erx/GetSite/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                setSiteData({ loading: false, site: data });
            })
            .catch(e => {
                // handle error here.
                setSiteData({ loading: false });
                console.log(e);
            });
    }
    function handleGetSiteDocuments(siteId) {
        var url = `Erx/GetSiteDocuments/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteDocsData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {

                const compareByCategory = (a, b) => {
                    const aCategory = a.category ?? "";
                    const bCategory = b.category ?? "";

                    const aMatch = aCategory.match(/^Tab (\d+)\b/i);
                    const bMatch = bCategory.match(/^Tab (\d+)\b/i);

                    const aIsTab = !!aMatch;
                    const bIsTab = !!bMatch;

                    if (aIsTab && bIsTab) {
                        return Number(aMatch[1]) - Number(bMatch[1]);
                    }

                    if (aIsTab) {
                        return -1;
                    }

                    if (bIsTab) {
                        return 1;
                    }

                    return aCategory.localeCompare(bCategory);
                }

                let sortedData = data.sort(compareByCategory);

                let docsByCategory = Object.values(
                    sortedData.reduce((acc, cv, i, arr) => {
                        let key = cv.category;
                        acc[key] = acc[key] || { key: key.toLowerCase().replace(/\s/g, ''), categoryName: key, documents: [] };
                        acc[key].documents.push(cv);
                        return acc;
                    }, {}));

                // let filteredDocsByCategory = docsByCategory.filter(x => x.key === 'permits' || x.key === 'swppp');
                // setSiteDocsData({ loading: false, siteDocs: filteredDocsByCategory });

                setSiteDocsData({ loading: false, siteDocs: docsByCategory });
            })
            .catch(e => {
                // handle error here.
                setSiteDocsData({ loading: false });
                console.log(e);
            });
    }
    function handleGetSiteInspections(siteId) {
        var url = `Erx/GetSiteInspections/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteInspectionsData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                let docsByCategory = data.reduce((acc, cv, i, arr) => {
                    let key = cv.category.toLowerCase().replace(/\s/g, '');
                    acc[key] = acc[key] || { key: key, categoryName: cv.category, documents: [] };
                    /*InspectionTypes---------*/
                    let InspType = cv.inspectionType || cv.category;
                    if (key === 'formlibrary') {
                        InspType = cv.category;
                    }

                    let InspTypeKey = InspType.toLowerCase().replace(/\s/g, '');

                    cv.inspectionTypeKey = InspTypeKey;

                    let inspectionTypes = acc[key].inspectionTypes || {};
                    inspectionTypes[InspTypeKey] = inspectionTypes[InspTypeKey] || { key: InspTypeKey, inspectionTypeName: InspType, documents: [] };
                    inspectionTypes[InspTypeKey].documents.push(cv);
                    acc[key].inspectionTypes = inspectionTypes;
                    /*---------InspectionTypes*/
                    return acc;
                }, {});

                docsByCategory = Object
                    .values({
                        dailylog: docsByCategory.dailylog,
                        npdes: docsByCategory.npdes,
                        pcir: docsByCategory.pcir,
                        ...docsByCategory
                    })
                    .filter(x => x !== undefined);

                docsByCategory = docsByCategory.map(x => {
                    if (x.key === "npdes") {
                        x.inspectionTypes = Object
                            .values({
                                routine: x.inspectionTypes.routine,
                                'routine/qualifyingevent': x.inspectionTypes['routine/qualifyingevent'],
                                qualifyingevent: x.inspectionTypes.qualifyingevent,
                                final: x.inspectionTypes.final,
                                other: x.inspectionTypes.other,
                                ...x.inspectionTypes
                            })
                            .filter(x => x !== undefined);
                    }
                    else {
                        x.inspectionTypes = Object.values(x.inspectionTypes);
                    }
                    
                    return x;
                });

                setSiteInspectionsData({ loading: false, siteDocs: docsByCategory });
            })
            .catch(e => {
                // handle error here.
                setSiteInspectionsData({ loading: false });
                console.log(e);
            });
    }
    function handleGetSiteAmendments(siteId) {
        var url = `Erx/GetSiteAmendments/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteAmendmentsData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                let docsByCategory = Object.values(
                    data.reduce((acc, cv, i, arr) => {
                        let key = cv.category;
                        acc[key] = acc[key] || { key: key.toLowerCase().replace(/\s/g, ''), categoryName: key, documents: [] };
                        acc[key].documents.push(cv);
                        return acc;
                    }, {}));
                setSiteAmendmentsData({ loading: false, siteDocs: docsByCategory });
            })
            .catch(e => {
                // handle error here.
                setSiteAmendmentsData({ loading: false });
                console.log(e);
            });
    }
    function handleGetSitePermits(siteId) {
        var url = `Erx/GetSitePermits/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSitePermitsData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                let docsByCategory = Object.values(
                    data.reduce((acc, cv, i, arr) => {
                        let key = cv.category;
                        acc[key] = acc[key] || { key: key.toLowerCase().replace(/\s/g, ''), categoryName: key, documents: [] };
                        acc[key].documents.push(cv);
                        return acc;
                    }, {}));
                setSitePermitsData({ loading: false, siteDocs: docsByCategory });
            })
            .catch(e => {
                // handle error here.
                setSitePermitsData({ loading: false });
                console.log(e);
            });
    }
    function handleGetSiteSwppps(siteId) {
        var url = `Erx/GetSiteSwppps/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteSwpppData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                let docsByCategory = Object.values(
                    data.reduce((acc, cv, i, arr) => {
                        let key = cv.category;
                        acc[key] = acc[key] || { key: key.toLowerCase().replace(/\s/g, ''), categoryName: key, documents: [] };
                        acc[key].documents.push(cv);
                        return acc;
                    }, {}));
                setSiteSwpppData({ loading: false, siteDocs: docsByCategory });
            })
            .catch(e => {
                // handle error here.
                setSiteSwpppData({ loading: false });
                console.log(e);
            });
    }
    function handleGetSiteContacts(siteId) {
        var url = `Erx/GetSiteContacts/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteContactsData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                setSiteContactsData({ loading: false, contacts: data });
            })
            .catch(e => {
                // handle error here.
                setSiteContactsData({ loading: false });
                console.log(e);
            });
    }
    function handleGetSiteGradingLogs(siteId, selectedMenuData) {
        if (selectedMenuData.selectedMenu !== "siteGradingLogs") { return; }

        var url = `Erx/GetSiteGradingLogs/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteGradingLogsData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                setSiteGradingLogsData({ loading: false, logs: data });
            })
            .catch(e => {
                // handle error here.
                setSiteGradingLogsData({ loading: false });
                console.log(e);
            });
    }
    function handleGetSiteGradingLogEntries(logId) {
        if (logId === undefined) {
            setSiteGradingLogEntriesData();
            return;
        }

        var url = `Erx/GetSiteGradingLogEntries/${logId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteGradingLogEntriesData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                setSiteGradingLogEntriesData({ loading: false, logs: data });
            })
            .catch(e => {
                // handle error here.
                setSiteGradingLogEntriesData();
                console.log(e);
            });
    }
    function handleGetSiteLotStabilizationLogs(siteId, selectedMenuData) {
        if (selectedMenuData.selectedMenu !== "siteLotStabilizationLogs") { return; }
        var url = `Erx/GetSiteLotStabilizationLogs/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteLotStabilizationLogsData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                setSiteLotStabilizationLogsData({ loading: false, logs: data });
            })
            .catch(e => {
                // handle error here.
                setSiteLotStabilizationLogsData({ loading: false });
                console.log(e);
            });
    }
    function handleGetSiteLotStabilizationLogEntries(logId) {
        if (logId === undefined) {
            setSiteLotStabilizationLogEntriesData();
            return;
        }

        var url = `Erx/GetSiteLotStabilizationLogEntries/${logId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteLotStabilizationLogEntriesData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                setSiteLotStabilizationLogEntriesData({ loading: false, logs: data });
            })
            .catch(e => {
                // handle error here.
                setSiteLotStabilizationLogEntriesData();
                console.log(e);
            });
    }
    function handleGetQualifyingEventLogs(siteId) {
        // if (selectedMenuData.selectedMenu !== "siteRainLogs") { return; }

        var url = `Erx/GetQualifyingEventLogs/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteQualifyingEventLogsData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                setSiteQualifyingEventLogsData({ loading: false, logs: data });
            })
            .catch(e => {
                // handle error here.
                setSiteQualifyingEventLogsData({ loading: false });
                console.log(e);
            });
    }
    function handleGetStormLogs(siteId) {
        // if (selectedMenuData.selectedMenu !== "siteRainLogs") { return; }

        var url = `Erx/GetStormLogs/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteStormLogsData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                setSiteStormLogsData({ loading: false, logs: data });
            })
            .catch(e => {
                // handle error here.
                setSiteStormLogsData({ loading: false });
                console.log(e);
            });
    }
    function handleGetRainLogs(siteId) {
        // if (selectedMenuData.selectedMenu !== "siteRainLogs") { return; }

        var url = `Erx/GetRainLogs/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteRainLogsData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                setSiteRainLogsData({ loading: false, logs: data });
            })
            .catch(e => {
                // handle error here.
                setSiteRainLogsData({ loading: false });
                console.log(e);
            });
    }
    function handleGetMaps(siteId) {
        // if (selectedMenuData.selectedMenu !== "siteMaps") { return; }

        var url = `Erx/GetMaps/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setSiteMapsData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                setSiteMapsData({ loading: false, maps: data });
            })
            .catch(e => {
                // handle error here.
                setSiteMapsData({ loading: false });
                console.log(e);
            });
    }
    function handleGetPermitSummaries(siteId, selectedMenuData) {
        if (selectedMenuData.selectedMenu !== "permitSummaries") { return; }

        var url = `Erx/GetPermitSummaries/${siteId}`;
        var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' } };

        setPermitSummariesData({ loading: true });
        fetch(url, requestInit)
            .then(response => {
                if (response.ok) { return response.json(); }
                return Promise.reject(response);
            })
            .then(data => {
                setPermitSummariesData({ loading: false, permits: data });
            })
            .catch(e => {
                // handle error here.
                setPermitSummariesData({ loading: false });
                console.log(e);
            });
    }


    function handleSelectSiteDoc(categoryKey, recordId) {
        const siteDocsCopy = siteDocsData.siteDocs;

        siteDocsCopy.map(category => {
            let categorySelected;
            if (category.key === categoryKey) {
                if (recordId === undefined) {
                    category.selected = !category.selected;
                }
                else {
                    category.selected = false;
                }

                categorySelected = category.selected;
            }

            let selectedCount = 0;
            category.documents.map(doc => {
                if (recordId !== undefined) {
                    if (doc.recordId === recordId) {
                        doc.selected = !doc.selected;
                    }
                }
                else if (categorySelected === true) {
                    doc.selected = true;
                }
                else if (categorySelected === false) {
                    doc.selected = false;
                }

                if (doc.selected) { ++selectedCount }

                return doc;
            });

            if (selectedCount === category.documents.length) {
                category.selected = true;
            }

            return category;
        });

        setSiteDocsData({ loading: false, siteDocs: siteDocsCopy });
    }
    function handleSelectSiteInsp(categoryKey, documentId, inspectionTypeKey) {
        const siteDocsCopy = siteInspectionsData.siteDocs;

        siteDocsCopy.map(category => {
            if (category.key === categoryKey) {
                if (inspectionTypeKey === undefined) {
                    category.selected = !category.selected;
                }
                category.inspectionTypes.map(inspectionType => {
                    let inspectionTypeSelected;

                    if (inspectionTypeKey === undefined) {
                        inspectionType.selected = category.selected;
                        inspectionTypeSelected = inspectionType.selected;
                    }
                    else {
                        if (inspectionType.key === inspectionTypeKey) {
                            if (documentId === undefined) {
                                inspectionType.selected = !inspectionType.selected;
                            }
                            else {
                                inspectionType.selected = false;
                                category.selected = false;
                            }

                            inspectionTypeSelected = inspectionType.selected;
                        }
                    }
                    let selectedCount = 0;
                    inspectionType.documents.map(doc => {
                        if (documentId !== undefined) {
                            if (doc.id === documentId && inspectionType.key === inspectionTypeKey) {
                                doc.selected = !doc.selected;
                            }
                        }
                        else if (inspectionTypeSelected === true) {
                            doc.selected = true;
                        }
                        else if (inspectionTypeSelected === false) {
                            doc.selected = false;
                        }

                        if (doc.selected) { ++selectedCount }

                        return doc;
                    });

                    if (selectedCount === inspectionType.documents.length) {
                        inspectionType.selected = true;
                    }

                    if (category.inspectionTypes.length === category.inspectionTypes.filter(x => x.selected).length) {
                        category.selected = true;
                    }

                    return inspectionType;
                });

            }
            
            return category;
        });

        setSiteInspectionsData({ loading: false, siteDocs: siteDocsCopy });
    }

    function handleSelectSiteMap(toggleAllMaps, documentId) {
        const siteDocsCopy = siteMapsData.maps;

        let selectedCount = 0;
        let selected = toggleAllMaps ? !siteMapsData.selected : false;
        siteDocsCopy.map(map => {
            if (toggleAllMaps) {
                map.selected = selected;
            }
            else {
                if (map.id === documentId) {
                    map.selected = !map.selected;
                }
            }

            if (map.selected) { ++selectedCount }

            return map;
        });

        if (selectedCount === siteDocsCopy.length) {
            selected = true;
        }

        setSiteMapsData({ loading: false, maps: siteDocsCopy, selected: selected });
    }

    function handleSelectSiteAmend(categoryKey, documentId) {
        let selectedCount = 0;
        const siteDocsCopy = siteAmendmentsData.siteDocs;

        siteDocsCopy.map(category => {
            let categorySelected;
            if (category.key === categoryKey) {
                if (documentId === undefined) {
                    category.selected = !category.selected;
                }
                else {
                    category.selected = false;
                }

                categorySelected = category.selected;
            }

            category.documents.map(doc => {
                if (documentId !== undefined) {
                    if (doc.id === documentId) {
                        doc.selected = !doc.selected;
                    }
                }
                else if (categorySelected === true) {
                    doc.selected = true;
                }
                else if (categorySelected === false) {
                    doc.selected = false;
                }

                if (doc.selected) { ++selectedCount }

                return doc;
            });

            return category;
        });

        setSiteAmendmentsData({ loading: false, siteDocs: siteDocsCopy });
    }
    function handleSelectSitePermit(categoryKey, documentId) {
        let selectedCount = 0;
        const siteDocsCopy = sitePermitsData.siteDocs;

        siteDocsCopy.map(category => {
            let categorySelected;
            if (category.key === categoryKey) {
                if (documentId === undefined) {
                    category.selected = !category.selected;
                }
                else {
                    category.selected = false;
                }

                categorySelected = category.selected;
            }

            category.documents.map(doc => {
                if (documentId !== undefined) {
                    if (doc.id === documentId) {
                        doc.selected = !doc.selected;
                    }
                }
                else if (categorySelected === true) {
                    doc.selected = true;
                }
                else if (categorySelected === false) {
                    doc.selected = false;
                }

                if (doc.selected) { ++selectedCount }

                return doc;
            });

            return category;
        });

        setSitePermitsData({ loading: false, siteDocs: siteDocsCopy });
    }
    function handleSelectSiteSwppp(categoryKey, documentId) {
        let selectedCount = 0;
        const siteDocsCopy = siteSwpppsData.siteDocs;

        siteDocsCopy.map(category => {
            let categorySelected;
            if (category.key === categoryKey) {
                if (documentId === undefined) {
                    category.selected = !category.selected;
                }
                else {
                    category.selected = false;
                }

                categorySelected = category.selected;
            }

            category.documents.map(doc => {
                if (documentId !== undefined) {
                    if (doc.id === documentId) {
                        doc.selected = !doc.selected;
                    }
                }
                else if (categorySelected === true) {
                    doc.selected = true;
                }
                else if (categorySelected === false) {
                    doc.selected = false;
                }

                if (doc.selected) { ++selectedCount }

                return doc;
            });

            return category;
        });

        setSiteSwpppData({ loading: false, siteDocs: siteDocsCopy });
    }

    function handleDownloadDocuments(categoryKey) {
        let attachmentIds = siteDocsData.siteDocs.filter(cat => cat.key === categoryKey).reduce((acc, cat) => {
            let ids = cat.documents.filter(doc => doc.selected).map(doc => doc.attachmentId);

            acc = acc.concat(ids);
            return acc;
        }, []);

        if (attachmentIds.length <= 0) {
            //TODO: handle no files selected.
            return Promise.reject(new Error("No files selected"));
        }

        setDownloadDocsProgress({ totalBatches: 1, completedBatches: 0, isDownloadCompleted: false, isSingleDocument: false, documentCont: attachmentIds.length });

        let abortController = new AbortController(); // Create a new abort controller for each batch
        abortDownloadRef.current = abortController; // Set it to the ref

        let url = `Erx/GetDocumentsInZip`;
        let criteria = { SiteId: siteId, SiteName: siteData.site.siteName, referenceIds: attachmentIds };
        let requestInit = { method: 'POST', headers: { 'Content-type': 'application/json' }, body: JSON.stringify(criteria), signal: abortController.signal };

        return fetch(url, requestInit)
            .then(response => {
                if (response.ok) {
                    return downloadBlobFromResponse(response).then(handleDownloadFinished);
                }
                return Promise.reject(response);
            })
            .catch(e => {
                // handle error here.
                console.log(e);
                handleDownloadFinished();
                if (e.status === 401) {
                    // setIsSessionExpired(true);
                    // window.location.reload(true);
                }
                // if (e.aborted) { }
                throw e; // Re-throw the error to be caught by the calling function
            });
    }

    function handleDownloadDocument(document, viewDocument=false) {
        if (document?.attachmentId !== undefined) {

            setDownloadDocsProgress({ totalBatches: 1, completedBatches: 0, isDownloadCompleted: false, isSingleDocument: true, documentCont: 1 });

            let abortController = new AbortController(); // Create a new abort controller for each batch
            abortDownloadRef.current = abortController; // Set it to the ref

            var url = `Erx/GetDocument/${siteId}/${document.recordType}/${document.attachmentId}`;
            var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' }, signal: abortController.signal };

            return fetch(url, requestInit)
                .then(response => handleStandardDocumentResponse({
                    document,
                    onDownloadFinished: handleDownloadFinished,
                    response,
                    setViewDocumentData,
                    viewDocument,
                }))
                .catch(e => {
                    // handle error here.
                    console.log(e);
                    handleDownloadFinished();
                    if (e.status === 401) {
                        // setIsSessionExpired(true);
                        // window.location.reload(true);
                    }
                    // if (e.aborted) { }
                    throw e; // Re-throw the error to be caught by the calling function
                });
        }
    }

    function handleDownloadInspections(categoryKey, inspectionTypeKey) {
        let inspectionIds = siteInspectionsData.siteDocs.filter(cat => cat.key === categoryKey).reduce((acc, cat) => {
            let types = cat.inspectionTypes.filter(type => type.key === inspectionTypeKey || inspectionTypeKey === undefined).reduce((acc, type) => {
                let docIds = type.documents.filter(doc => doc.selected).map(doc => doc.id);

                acc = acc.concat(docIds);
                return acc;
            }, []);

            acc = acc.concat(types);
            return acc;
        }, []);

        if (inspectionIds.length <= 0) {
            //TODO: handle no files selected.
            return Promise.reject(new Error("No files selected"));
        }

        setDownloadDocsProgress({ totalBatches: 1, completedBatches: 0, isDownloadCompleted: false, isSingleDocument: false, documentCont: inspectionIds.length });

        let abortController = new AbortController(); // Create a new abort controller for each batch
        abortDownloadRef.current = abortController; // Set it to the ref

        let url = `Erx/GetInspectionsDocsInZip`;
        let criteria = { SiteId: siteId, SiteName: siteData.site.siteName, referenceIds: inspectionIds };
        let requestInit = { method: 'POST', headers: { 'Content-type': 'application/json' }, body: JSON.stringify(criteria), signal: abortController.signal };

        return fetch(url, requestInit)
            .then(response => {
                if (response.ok) {
                    return downloadBlobFromResponse(response).then(handleDownloadFinished);
                }
                return Promise.reject(response);
            })
            .catch(e => {
                // handle error here.
                console.log(e);
                handleDownloadFinished();
                if (e.status === 401) {
                    // setIsSessionExpired(true);
                    // window.location.reload(true);
                }
                // if (e.aborted) { }
                throw e; // Re-throw the error to be caught by the calling function
            });
    }

    function handleDownloadInspection(document, viewDocument=false) {
        if (document?.id !== undefined) {

            setDownloadDocsProgress({ totalBatches: 1, completedBatches: 0, isDownloadCompleted: false, isSingleDocument: true, documentCont: 1 });

            let abortController = new AbortController(); // Create a new abort controller for each batch
            abortDownloadRef.current = abortController; // Set it to the ref

            var url = `Erx/GetInspection/${siteId}/${document.id}`;
            var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' }, signal: abortController.signal };

            return fetch(url, requestInit)
                .then(response => handleStandardDocumentResponse({
                    document,
                    onDownloadFinished: handleDownloadFinished,
                    response,
                    setViewDocumentData,
                    viewDocument,
                }))
                .catch(e => {
                    // handle error here.
                    console.log(e);
                    handleDownloadFinished();
                    if (e.status === 401) {
                        // setIsSessionExpired(true);
                        // window.location.reload(true);
                    }
                    // if (e.aborted) { }
                    throw e; // Re-throw the error to be caught by the calling function
                });
        }
    }

    function handleDownloadMaps() {
        const selectedMaps = getSelectedMapLatestRevisions(siteMapsData.maps);

        if (selectedMaps.length <= 0) {
            //TODO: handle no files selected.
            return Promise.reject(new Error("No maps selected"));
        }

        setDownloadDocsProgress({
            totalBatches: selectedMaps.length,
            completedBatches: 0,
            isDownloadCompleted: false,
            isSingleDocument: false,
            documentCont: selectedMaps.length,
        });

        let abortController = new AbortController(); // Create a new abort controller for each batch
        abortDownloadRef.current = abortController; // Set it to the ref

        return selectedMaps.reduce(
            (pendingPromise, mapItem, index) => pendingPromise.then(async zipEntries => {
                const url = `Erx/GetMap/${siteId}/${mapItem.revision.mapId}/${mapItem.revision.revisionId}`;
                const requestInit = {
                    method: 'GET',
                    headers: { 'Content-type': 'application/json' },
                    signal: abortController.signal,
                };

                const response = await fetch(url, requestInit);
                const pdfDocument = await createMapPdfFromRevisionResponse({
                    map: mapItem.map,
                    response,
                    revision: mapItem.revision,
                    site: siteData.site,
                });

                setDownloadDocsProgress(currentProgress => ({
                    ...currentProgress,
                    completedBatches: index + 1,
                }));

                return zipEntries.concat({
                    blob: pdfDocument.blob,
                    name: pdfDocument.fileName,
                });
            }),
            Promise.resolve([])
        )
            .then(async zipEntries => {
                if (abortController.signal.aborted) {
                    return Promise.reject(new DOMException('The operation was aborted.', 'AbortError'));
                }

                const zipBlob = await createZipBlob(zipEntries);
                downloadBlob(zipBlob, `${siteData.site.siteName}_SelectedMapsPdfs.zip`);
                handleDownloadFinished();
                return zipEntries.length;
            })
            .catch(e => {
                // handle error here.
                console.log(e);
                handleDownloadFinished();
                if (e.status === 401) {
                    // setIsSessionExpired(true);
                    // window.location.reload(true);
                }
                // if (e.aborted) { }
                throw e; // Re-throw the error to be caught by the calling function
            });
    }

    function getMapForRevision(revision) {
        return siteMapsData.maps?.find(map =>
            map.revisions?.some(mapRevision => mapRevision.revisionId === revision?.revisionId)
        );
    }

    function handleDownloadMap(revision, viewDocument=false) {
        if (revision.mapId !== undefined && revision.revisionId !== undefined) {

            setDownloadDocsProgress({ totalBatches: 1, completedBatches: 0, isDownloadCompleted: false, isSingleDocument: true, documentCont: 1 });

            let abortController = new AbortController(); // Create a new abort controller for each batch
            abortDownloadRef.current = abortController; // Set it to the ref

            var url = `Erx/GetMap/${siteId}/${revision.mapId}/${revision.revisionId}`;
            var requestInit = { method: 'GET', headers: { 'Content-type': 'application/json' }, signal: abortController.signal };
            const map = getMapForRevision(revision);

            return fetch(url, requestInit)
                .then(response => handleMapDocumentResponse({
                    map,
                    onDownloadFinished: handleDownloadFinished,
                    response,
                    revision,
                    setViewDocumentData,
                    site: siteData.site,
                    viewDocument,
                }))
                .catch(e => {
                    // handle error here.
                    console.log(e);
                    handleDownloadFinished();
                    if (e.status === 401) {
                        // setIsSessionExpired(true);
                        // window.location.reload(true);
                    }
                    // if (e.aborted) { }
                    throw e; // Re-throw the error to be caught by the calling function
                });
        }
    }

    function handleDownloadFinished() {
        clearTimeout(downloadTimeoutRef.current);
        downloadTimeoutRef.current = setTimeout(() =>
            setDownloadDocsProgress({ totalBatches: 1, completedBatches: 1, isDownloadCompleted: true, isSingleDocument: false, documentCont: 0 }),
            350);
    }

    function handleAbortDownload() {
        if (abortDownloadRef.current) {
            abortDownloadRef.current.abort();
        }
        handleDownloadFinished();
    }

    /////////////////////////////////////////////
    function handleNavigationClick(selectedMenu) {
        setSelectedMenuData({ selectedMenu, selectedOn: new Date() });
    }
    function hadleCloseViewer() {
        if (viewerDocumentData?.src !== undefined) {
            window.URL.revokeObjectURL(viewerDocumentData.src)
        }
        setViewDocumentData();
    }

    function handleStormwaterDownloadInspection(document) {
        handleDownloadInspection(document);
    }
    function handleStormwaterViewInspection(document, download = false) {
        if (document?.id !== undefined && document?.id !== 0) {
            handleDownloadInspection(document, true);
            return;
        }
        setViewDocumentData();
    }

    function handleStormwaterDownloadMap(revision) {
        handleDownloadMap(revision);
    }
    function handleStormwaterViewMap(revision, download = false) {
        if (revision?.mapId !== undefined && revision?.mapId !== 0) {
            handleDownloadMap(revision, true);
            return;
        }
        setViewDocumentData();
    }

    function handleStormwaterDownloadDoc(document) {
        handleDownloadDocument(document);
    }    

    function handleStormwaterViewDoc(document, download = false) {
        if (document?.attachmentId !== undefined) {
            handleDownloadDocument(document, true);
            return;
        }
        setViewDocumentData();
    }

    function handleGetErxUrlAndViewDoc(document, download = false) {
        if (document?.attachmentId !== undefined) {
            //Get Erx Url
            var url = `Erx/GetDocumentUrl/${siteId}/${document.recordType}/${document.attachmentId}`;
            var requestInit = {
                method: 'GET',
                headers: { 'Content-type': 'application/json' },
            };

            setViewDocumentData();
            fetch(url, requestInit)
                .then(response => {
                    if (response.ok) { return response.json(); }
                    return Promise.reject(response);
                })
                .then(data => {
                    setViewDocumentData({
                        src: data.docUrl,
                        type: document.mimeType,
                        filename: document.fileName,
                        download: download,
                    });
                })
                .catch(e => {
                    // handle error here.
                    setViewDocumentData();
                    console.log(e);
                });

            return;
        }
        setViewDocumentData();
    }

    /*Download Files Modal-------------*/
    let isSingleDocument = downloadDocsProgress.isSingleDocument;
    let completedBatches = downloadDocsProgress.completedBatches;
    let totalBatches = downloadDocsProgress.totalBatches;
    let progressValue = 100 * (completedBatches + 1) / (totalBatches + 1);
    let documentCont = downloadDocsProgress.documentCont;

    let waiting = isSingleDocument === false && totalBatches > 1 ? (<>
        <br />
        <h5>Getting batch {Math.min(completedBatches + 1, totalBatches)} of {totalBatches}.</h5>
        <div className="progress">
            <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                style={{ width: `${progressValue}%` }} aria-valuenow={progressValue}
                aria-valuemin="0" aria-valuemax="100">
            </div>
        </div>
    </>) : (<div className="spinnerContainer"><i className="dhicon-spin5 animate-spin" /></div>);

    let downloadingMessage = isSingleDocument ? "Downloading your document." : `Downloading ${documentCont} document${documentCont > 1 ? "s" : ""}.`;
    let zippingMessage = isSingleDocument ? undefined : (<><br /><h5>Please wait, I'm zipping up your document{documentCont > 1 ? "s" : ""}.</h5></>);

    let downloadFilesModal = !downloadDocsProgress.isDownloadCompleted && (<ModalComponent>
        <h4 className="font-bold">{downloadingMessage}</h4>
        {zippingMessage}
        {waiting}
        <div className="buttonContainer">
            <button className="button" onClick={handleAbortDownload}>Cancel</button>
        </div>
    </ModalComponent>);
    /*-------------Download Files Modal*/

    let stormwaterNavItems = undefined 
    let content = (<SWHome />);
    if (siteId !== undefined) {
        content = (<>
            <StormwaterProject siteData={siteData}>
                <Routes>
                    <Route path='siteInspections' element={<InspectionContainer sectionName="Inspections" sectionIcon="dhicon-inspection" siteDocsData={siteInspectionsData} onSelectDoc={handleSelectSiteInsp} viewDoc={handleStormwaterViewInspection} downloadDoc={handleStormwaterDownloadInspection} downloadAll={handleDownloadInspections} />} />
                    <Route path='siteDocs' element={<SiteDocsContainer sectionName="Uploaded Documents" sectionIcon="dhicon-action-item-completed" siteDocsData={siteDocsData} onSelectDoc={handleSelectSiteDoc} viewDoc={handleStormwaterViewDoc} downloadDoc={handleStormwaterDownloadDoc} downloadAll={handleDownloadDocuments} />} />
                    <Route path='siteRainLogs' element={<SiteRainLogsContainer sectionName="Rain Logs" sectionIcon="dhicon-stormwater-rain-log"
                        site={siteData.site}
                        siteQualifyingEventLogsData={siteQualifyingEventLogsData}
                        siteStormLogsData={siteStormLogsData}
                        siteRainLogsData={siteRainLogsData}
                    />} />
                    <Route path='siteMaps' element={<MapsContainer sectionName="Active Site Map" sectionIcon="dhicon-sitemap-option-2" siteMapsData={siteMapsData} onSelectDoc={handleSelectSiteMap} viewDoc={handleStormwaterViewMap} downloadDoc={handleStormwaterDownloadMap} downloadAll={handleDownloadMaps} />} />
                    <Route path='siteGradingLogs' element={<SiteLogsContainer sectionName="Land Development Activity and Stabilization Log" sectionIcon="dhicon-bulldozer"
                        site={siteData.site}
                        siteGradingLogsData={siteGradingLogsData}
                        siteGradingLogEntriesData={siteGradingLogEntriesData}
                        onShowEntries={handleGetSiteGradingLogEntries}
                        closeLogEntries={() => handleGetSiteGradingLogEntries()}
                    />} />
                    <Route path='siteLotStabilizationLogs' element={<SiteLogsContainer sectionName="Lot Activity and Stabilization Log" sectionIcon="dhicon-bulldozer-1"
                        site={siteData.site}
                        siteLotStabilizationLogsData={siteLotStabilizationLogsData}
                        siteLotStabilizationLogEntriesData={siteLotStabilizationLogEntriesData}
                        onShowEntries={handleGetSiteLotStabilizationLogEntries}
                        closeLogEntries={() => handleGetSiteLotStabilizationLogEntries()}
                    />} />
                    <Route path='siteContacts' element={<SiteContactsContainer sectionName="Contacts" sectionIcon="dhicon-stormwater-contact" inspectorUserId={0} siteContactsData={siteContactsData} />} />

                    <Route path='siteSwppps' element={<SiteDocsContainer sectionName="SWPPP" sectionIcon="dhicon-site1" siteDocsData={siteSwpppsData} onSelectDoc={handleSelectSiteSwppp} viewDoc={handleStormwaterViewDoc} downloadDoc={handleStormwaterDownloadDoc} />} />
                    <Route path='siteAmendments' element={<SiteDocsContainer sectionName="Amendments" sectionIcon="dhicon-edit" siteDocsData={siteAmendmentsData} onSelectDoc={handleSelectSiteAmend} viewDoc={handleStormwaterViewDoc} downloadDoc={handleStormwaterDownloadDoc} />} />
                    <Route path='sitePermits' element={<SiteDocsContainer sectionName="Permits" sectionIcon="dhicon-final" siteDocsData={sitePermitsData} onSelectDoc={handleSelectSitePermit} viewDoc={handleStormwaterViewDoc} downloadDoc={handleStormwaterDownloadDoc} />} />
                    <Route path='permitSummaries' element={<PermitContainer sectionName="Permits" sectionIcon="dhicon-final" permitSummariesData={permitSummariesData} />} />
                </Routes>
            </StormwaterProject>
            {downloadFilesModal}
        </>);

        stormwaterNavItems = [
            { path: "siteInspections", name: "Inspections", iconClass: "dhicon-inspection" },
            { path: "siteDocs", name: "Uploaded Documents", iconClass: "dhicon-action-item-completed" },
            { path: "siteRainLogs", name: "Rain Logs", iconClass: "dhicon-stormwater-rain-log" },
            { path: "siteMaps", name: "Maps", iconClass: "dhicon-sitemap-option-2" },
            { path: "siteGradingLogs", name: "Land Development Activity and Stabilization Log", iconClass: "dhicon-bulldozer" },
            { path: "siteLotStabilizationLogs", name: "Lot Activity and Stabilization Log", iconClass: "dhicon-bulldozer-1" },
            { path: "siteContacts", name: "Contacts", iconClass: "dhicon-stormwater-contact" },
            
            /*{ path: "siteSwppps", name: "SWPPP", iconClass: "dhicon-site1" },*/
            /*{ path: "siteAmendments", name: "Amendments", iconClass: "dhicon-edit" },*/
            /*{ path: "sitePermits", name: "Permits", iconClass: "dhicon-final" },*/
            /*{ path: "permitSummaries", name: "Permit Summaries", iconClass: "dhicon-final" },*/
        ];
    }

    return (<StormwaterLayout basePath="/stormwater"
        navigationItems={stormwaterNavItems}
        onNavigationClick={handleNavigationClick}
        selectedMenu={selectedMenuData.selectedMenu}
        viewerDocumentData={viewerDocumentData}
        closeViewer={hadleCloseViewer}>
        {content}
    </StormwaterLayout>);
}
